export const WHO_LIKED_PAGE_SIZE = 50;
